import { Brand } from '@basis-theory/react-elements'

interface CardTypeValue {
  id?: number
  name?: string
}

const normalizeCardTypeName = (name?: string): string => {
  return (name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-_]/g, '')
}

const mapCardTypeIdToBrand = (id?: number): Brand | undefined => {
  switch (id) {
    case 1:
      return 'visa'
    case 2:
      return 'mastercard'
    case 3:
      return 'maestro'
    case 4:
      return 'american-express'
    case 5:
      return 'discover'
    case 6:
      return 'diners-club'
    case 7:
      return 'jcb'
    case 8:
      return 'unionpay'
    case 9:
      return 'cartes-bancaires'
    case 12:
      return 'elo'
    case 13:
      return 'hiper'
    case 14:
      return 'hipercard'
    case 99:
      return 'unknown'
    default:
      return undefined
  }
}

export const mapCardTypeNameToBrand = (name?: string): Brand => {
  const normalized = normalizeCardTypeName(name)

  switch (normalized) {
    case 'visa':
      return 'visa'
    case 'mastercard':
      return 'mastercard'
    case 'maestro':
      return 'maestro'
    case 'americanexpress':
    case 'amex':
      return 'american-express'
    case 'discover':
      return 'discover'
    case 'dinersclub':
      return 'diners-club'
    case 'jcb':
    case 'jsb':
      return 'jcb'
    case 'unionpay':
      return 'unionpay'
    case 'cartesbancaires':
    case 'cb':
      return 'cartes-bancaires'
    case 'elo':
      return 'elo'
    case 'hiper':
      return 'hiper'
    case 'hipercard':
      return 'hipercard'
    default:
      return 'unknown'
  }
}

export const mapCardTypeToBrand = (cardType?: CardTypeValue): Brand => {
  const byId = mapCardTypeIdToBrand(cardType?.id)
  if (byId) {
    return byId
  }
  return mapCardTypeNameToBrand(cardType?.name)
}
